<template>
  <h2 class="pb-2 border-bottom">Medicamentos para Perda de Peso</h2>
  <div class="wl-flex">
    <div class="wl-content">
      <ul>
    <li>Tirzepatida (Mounjaro, Zepbound) – Agonista dual GIP/GLP-1, demonstrado ser ainda mais eficaz para perda de peso</li>
    <li>Liraglutida (Saxenda) – Injeção diária, uma alternativa para pacientes que preferem não tomar semanalmente</li>
  </ul>
  <p> Pacientes podem perder 10-20% do peso corporal com esses medicamentos quando combinados com mudanças de estilo de vida.</p>

  <h5>Estrutura do Programa de Perda de Peso</h5>
  <ul>
    <li>Consulta Inicial & Avaliação
      <ul>
        <li>Histórico médico abrangente & avaliação de peso</li>
        <li>Plano de perda de peso personalizado com base em objetivos & condições de saúde</li>
      </ul>
    </li>
    <li>Plano de Medicação GLP-1
      <ul>
        <li>Cronograma de dosagem personalizado com base nas necessidades do paciente</li>
        <li>Orientação sobre efeitos colaterais & como gerenciar náusea</li>
        <li>Monitoramento contínuo & ajustes de dosagem</li>
      </ul>
    </li>
    <li>Coaching de Nutrição & Estilo de Vida
      <ul>
        <li>Planejamento de refeições & orientação de controle de porções</li>
      </ul>
    </li>
    <li>Check-ins Mensais & Acompanhamento de Progresso via mensagem de texto</li>
  </ul>
    </div>
    <div class="wl-videos">
      <iframe width="320" height="568" style="max-width:100%; border-radius: 12px; box-shadow: 0 4px 24px rgba(0,0,0,0.08); margin-bottom: 1.5rem;" src="https://www.youtube.com/embed/L1P7TDXi-3g" title="YouTube Shorts: Perda de Peso 1" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
      <iframe width="320" height="568" style="max-width:100%; border-radius: 12px; box-shadow: 0 4px 24px rgba(0,0,0,0.08);" src="https://www.youtube.com/embed/VVgrgvhakKY" title="YouTube Shorts: Perda de Peso 2" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WeightLossContentPtBR'
};
</script>

<style scoped>
.wl-flex {
  display: flex;
  gap: 2rem;
  flex-wrap: wrap;
  align-items: flex-start;
  margin-top: 1.5rem;
}
.wl-content {
  flex: 1 1 340px;
  min-width: 0;
}
.wl-videos {
  flex: 0 0 340px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}
@media (max-width: 900px) {
  .wl-flex {
    flex-direction: column;
    gap: 1.5rem;
  }
  .wl-videos {
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;
    margin: 0 auto;
    gap: 1rem;
  }
  .wl-videos iframe {
    width: 48vw;
    height: 270px;
    min-width: 160px;
    max-width: 100%;
  }
}
</style>
